import React from 'react'
import { Chart } from 'react-chartjs-2'

import { GranularityEnum, IGenericBucket } from '../types'

import {
  buildHistogramOptions,
  getChartPlugins,
  getLabelsWithGranularity,
  IGraphProps,
  STYLE_CHART_CONTAINER,
} from './graphCommons'
import { useGraphContext } from './GraphWrapper/GraphWrappers'
import { DEFAULT_DATASET_STYLES } from './themes'

const getDocCount = (bucket: IGenericBucket): number => bucket.doc_count || 0

interface IProps extends IGraphProps {
  enableAnimation?: boolean
  granularity: GranularityEnum
}

function TemporalHistogram({
  title = '',
  showTitle,
  w = 600,
  h = 300,
  rawData,
  formatWithUnit,
  granularity,
  maxValue = 0,
  enableAnimation = true,
  xTicksFormatter,
}: IProps) {
  const { reactChart } = useGraphContext()

  const datasets: any[] = [
    {
      ...DEFAULT_DATASET_STYLES[0],
      label: '',
      data: rawData.map(getDocCount),
    },
  ]
  const labels: string | string[] = getLabelsWithGranularity(rawData, granularity)

  const options = buildHistogramOptions({
    title,
    showTitle,
    maxValue,
    enableAnimation,
    formatWithUnit,
    xTicksFormatter,
    displayLegend: false,
    horizontal: false,
  })

  const plugins = getChartPlugins()

  return (
    <div style={STYLE_CHART_CONTAINER}>
      <Chart
        title={title}
        ref={reactChart.chartRef}
        type="bar"
        data={{ datasets, labels }}
        width={w}
        height={h}
        options={options}
        plugins={plugins}
      />
    </div>
  )
}

export default TemporalHistogram
